import { render } from "./AddCash.vue?vue&type=template&id=9b2c098a&scoped=true"
import script from "./AddCash.vue?vue&type=script&lang=js"
export * from "./AddCash.vue?vue&type=script&lang=js"

import "./AddCash.vue?vue&type=style&index=0&id=9b2c098a&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b2c098a"]])

export default __exports__